import cn from 'classnames'

import Container from 'layouts/container'

import { Carousel } from 'components/carousel'
import { Slide } from 'components/carousel/slide'
import ImageComponent from 'components/image'
import Link from 'components/link'
import Spinner from 'components/spinner'

import { CarouselBanner as CarouselSliderType } from 'hooks/retailer/use-get-carousel-banners'

import css from './carousel-slider.module.scss'

const SINGLE_SLIDE_DURATION = 5000
let width = 1280
let height = 300
let objectFit = 'cover' as 'contain' | 'cover'

type LinkWrapperProps = { url: string | undefined; children: React.ReactNode }

const LinkWrapper = ({ url, children }: LinkWrapperProps) => {
  if (url) {
    return (
      <Link href={url} target="_blank">
        {children}
      </Link>
    )
  }
  return <div>{children}</div>
}

type CarouselSliderProps = { className?: string; banners: CarouselSliderType[]; isLoading: boolean }

const CarouselSlider = ({ className, banners, isLoading }: CarouselSliderProps) => {
  if (document.body.clientWidth < 1280) {
    width = document.body.clientWidth || 390
    height = 250
    objectFit = 'contain'
  }

  const slides = banners.map(
    (slide) =>
      slide.imgUrl && (
        <Slide key={slide.name}>
          <LinkWrapper url={slide.url}>
            <div className={cn(css.slideWrapper, slide.url && css.slideLink)}>
              <ImageComponent
                className={cn(css.slideImage, !slide.imgUrl && css.imagePlaceholder)}
                src={slide.imgUrl}
                width={width}
                height={height}
                alt={slide.name}
                objectFit={objectFit}
              />
            </div>
          </LinkWrapper>
        </Slide>
      )
  )

  return (
    <div className={cn([css.container, className])}>
      <Container className={css.innerContainer}>
        <div className={css.carouselWrapper}>
          {isLoading ? (
            <Carousel
              className={cn(['swiper-pagination-keypoint-unbounded-width', 'swiper-wrapper--rounded'])}
              slides={[
                <Slide key={'loaderSlide'}>
                  <div className={css.slideWrapper}>
                    <Spinner loading={true} />
                  </div>
                </Slide>,
              ]}
              slidesPerView={1}
              loop
              autoplay={{
                delay: SINGLE_SLIDE_DURATION,
                disableOnInteraction: false,
              }}
            />
          ) : (
            <Carousel
              className={cn(['swiper-pagination-keypoint-unbounded-width', 'swiper-wrapper--rounded'])}
              slides={slides}
              slidesPerView={1}
              loop
              autoplay={{
                delay: SINGLE_SLIDE_DURATION,
                disableOnInteraction: false,
              }}
            />
          )}
        </div>
      </Container>
    </div>
  )
}

export default CarouselSlider
